import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { CartProvider } from "./components/CartContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";

// Every request to OUR api carries the signed-in identity, so the API can
// authorise against the token instead of trusting ids sent in the body.
//
// Scoped deliberately: an earlier version attached the header to every axios
// call, including a POST to a third-party description service on another host
// over plain http -- which handed that host a live session token. Credentials
// now go only to the API base this bundle was built against.
const API_BASE = `${process.env.REACT_APP_HOST || ""}${process.env.REACT_APP_PORT || ""}`;

function isOurApi(url) {
  if (!url) return false;
  // Relative urls can only resolve to our own origin.
  const lower = url.toLowerCase();
  const isAbsolute = lower.indexOf("http://") === 0 || lower.indexOf("https://") === 0;
  if (!isAbsolute) return true;
  return Boolean(API_BASE) && url.indexOf(API_BASE) === 0;
}

axios.interceptors.request.use((config) => {
  if (!isOurApi(config.url)) return config;
  const token = localStorage.getItem("accessToken");
  if (token && token !== "undefined" && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENTID}>
      <CartProvider>
      <BrowserRouter>
        <App />
        </BrowserRouter>
      </CartProvider>
    </GoogleOAuthProvider>
  </QueryClientProvider>
);
